import { pixiStrategy } from '@slot-nx/otel'
import { app } from '../pixi-app'
import { Ga4EventType } from './Ga4EventType'

export class Ga4Info {
  private playerId = ''
  private startTutorialTime: number
  public autoPlayCount = 0 as number
  public speedModeCount = 0 as number
  public immediateStopCount = 0 as number
  public hasRecordedPlaceMainBet = false
  public hasRecordedPlaceBonusBet = false
  public hasRecordedPlaceExtraBet = false

  public setPlayerId = (playerId: string) => {
    this.playerId = playerId
  }

  public recordGodziLoadingTime = () => {
    this.startTutorialTime = new Date().getTime()
    if (!window?.performance) return
    const loadingTime = (this.startTutorialTime - window.performance.timing.navigationStart) / 1000
    this.addEvent(Ga4EventType.godzi_loading)
    this.addEventSec(Ga4EventType.godzi_loading_time, Math.round(loadingTime * 100) / 100)
  }

  public skipTutorial = () => { // 沒再用了，請用measureFps
    const stayTutorialSec = (new Date().getTime() - this.startTutorialTime) / 1000
    this.addEventSec(Ga4EventType.tutorial_loading_time, Math.round(stayTutorialSec * 100) / 100)
    this.recordFPS()
  }

  public addEvent = (action: string, data?: Record<string, string>) => {
    if (window.gtag) {
      window.gtag('event', action, {
        playerId: this.playerId,
        ...data,
      })
    }
  }

  public addEventSec = (action: string, seconds: number) => {
    if (window.gtag) {
      window.gtag('event', action, {
        playerId: this.playerId,
        seconds,
      })
    }
  }

  public recordFPS(maxTime = 60) {
    const fpsList: number[] = []
    let frameCount = 0
    let lastTime = performance.now()
    const fpsUpdateInterval = 1000 // Update FPS display every second

    const calcFps = () => {
      frameCount++
      const currentTime = performance.now()
      const elapsed = currentTime - lastTime

      if (elapsed >= fpsUpdateInterval) {
        const fps = Math.round((frameCount * 1000) / elapsed)
        fpsList.push(fps)
        // Reset counters
        frameCount = 0
        lastTime = currentTime
        if (fpsList.length >= maxTime) {
          app.ticker.remove(calcFps)
          const averageFps = Math.round(fpsList.reduce((a, b) => a + b, 0) / fpsList.length)
          this.addEvent(`${Ga4EventType.avg_FPS}_${averageFps}`)
        }
      }
    }

    app.ticker.add(calcFps)
  }

  public measureFps(count = 10, interval = 5000) {
    const fpsArr: number[] = []

    const id = setInterval(async () => {
      if (fpsArr.length >= count) {
        const avg = Math.floor(
          fpsArr.reduce((a, b) => a + b, 0) / fpsArr.length,
        )
        this.addEvent(`${Ga4EventType.avg_FPS}`, { fps: `${avg}` })
        clearInterval(id)
      }
      else fpsArr.push(await pixiStrategy())
    }, interval)
  }

  public recordStayTime() {
    const timeoutDurations = [10000, 20000, 30000, 60000, 120000, 180000]
    timeoutDurations.forEach((duration) => {
      setTimeout(() => {
        this.addEvent(`stay_time_${duration / 1000}`)
      }, duration)
    })
  }

  public recordAutoPlay() {
    this.autoPlayCount++
    if (this.autoPlayCount === 10) {
      this.addEvent(Ga4EventType.spin_with_auto)
    }
  }

  public recordSpeedTurboMode() {
    this.speedModeCount++
    if (this.speedModeCount === 10) {
      this.addEvent(Ga4EventType.spin_with_speed)
    }
  }

  public recordImmediateStop() {
    this.immediateStopCount++
    if (this.immediateStopCount === 10) {
      this.addEvent(Ga4EventType.spin_with_immediate)
    }
  }

  public recordPlaceMainBet() {
    if (!this.hasRecordedPlaceMainBet) {
      this.addEvent(Ga4EventType.main_bet)
      this.hasRecordedPlaceMainBet = true
    }
  }

  public recordPlaceBonusBet() {
    if (!this.hasRecordedPlaceBonusBet) {
      this.addEvent(Ga4EventType.main_bet_bonus)
      this.hasRecordedPlaceBonusBet = true
    }
  }

  public recordPlaceExtraBet() {
    if (!this.hasRecordedPlaceExtraBet) {
      this.addEvent(Ga4EventType.main_bet_extra)
      this.hasRecordedPlaceExtraBet = true
    }
  }
}
